import { render, staticRenderFns } from "./ViewVehicle.vue?vue&type=template&id=45896116&scoped=true"
import script from "./ViewVehicle.vue?vue&type=script&lang=js"
export * from "./ViewVehicle.vue?vue&type=script&lang=js"
import style0 from "./ViewVehicle.vue?vue&type=style&index=0&id=45896116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45896116",
  null
  
)

export default component.exports